import React from 'react';
import styled from 'styled-components'
import Utils from './Utils'

import PageWrapper from './PageWrapper';
import { MixerLogo, InformationItem, SessionClickableContainer, FormField, SessionTextArea, RowFlexDiv, ColFlexDiv, MixerlabText } from './Components';

const ActorInstructions = (
  <ul>
    <li>Click on a past session name to view KPI details.</li>
    <li>Kickoff or end a session.</li>
  </ul>
  )

class ActorAdmin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeSession: this.props.activeSession,
      botSession: this.props.botSession,
      botTrainingSession: this.props.botTrainingSession,
      pastSessionKPIs: JSON.parse(this.props.pastSessionKPIs.replaceAll("&#34;", "\"")),
      session_spec_name: '',
      end_session_method: 'wait_and_cleanup',
      sessionSpecs: [],
      total_cost: '',
      hrs_conv_collected: '',
      num_conv_collected: '',
      viewable_session_name: '',
      tempkey: ''
    } 
    this.handleViewSessionKPIs = this.handleViewSessionKPIs.bind(this);
  }

  componentDidMount() {
    Utils.apiGet(
      '/actor/get_session_specs').then((response) => {
        this.setState({'sessionSpecs': response.data.session_specs})
    }).then(() => {this.updateState()})
  }

  updateState() {
    Utils.apiGet(
      '/actor/actor_home_updates').then((response) => {
        console.log(response.data)
        this.setState({'activeSession': response.data.active_session,
                      'botSession': response.data.bot_session,
                      'botTrainingSession': response.data.bot_training_session,
                    })
    }).then(() => {this.updateStatePeriodically()});
  }

  updateStatePeriodically() {
    if (this.periodicStatusCheck) {
      window.clearTimeout(this.periodicStatusCheck);
      this.periodicStatusCheck = null;
    }

    this.periodicStatusCheck = window.setTimeout(
      this.updateState.bind(this),
      60000
    );
  }

  handleViewSessionKPIs(session_name) {
    const viewableSessionData = this.state.pastSessionKPIs[session_name];
    this.setState({'total_cost': viewableSessionData['total_cost'],
      'hrs_conv_collected': viewableSessionData['hrs_conv_collected'],
      'num_conv_collected': viewableSessionData['num_conv_collected'],
      'viewable_session_name': viewableSessionData['session_name'],
    })}

  render() {
    const activeSession = parseInt(this.state.activeSession)
    const botSession = parseInt(this.state.botSession)
    const botTrainingSession = parseInt(this.state.botTrainingSession)
    const isAdmin = parseInt(this.props.isAdmin);

    let sessionSpecs = this.state.sessionSpecs.map((session_spec_name) => <option value={session_spec_name}>{session_spec_name}</option>)

    return (
      <PageWrapper isAdmin={this.props.isAdmin}>
        <h1>Actor Admin Page</h1>
        <MixerlabText>{ActorInstructions}</MixerlabText>
        <h1>Past Session KPI's</h1>
        {(this.state.viewable_session_name) && 
          <div>
            <h3>
              <InformationItem>Viewing KPIs for session: {this.state.viewable_session_name}</InformationItem>
            </h3>
            <div style={{ textAlign: 'center'}}>
              <InformationItem>Num conv collected: {this.state.num_conv_collected}</InformationItem>
              <InformationItem>Hours conv collected: {this.state.hrs_conv_collected}</InformationItem>
              <InformationItem>Total cost: {this.state.total_cost}</InformationItem>
            </div>
          </div>
        }
        <ul>
          {Object.keys(this.state.pastSessionKPIs).map((session_name) => 
          <li key={session_name}>
            <InformationItem onClick={() => this.handleViewSessionKPIs(session_name)}>{session_name}</InformationItem>
          </li>
          )} 
        </ul>
        {(!!isAdmin) &&
          <ColFlexDiv style={{'width': '80%'}}>
            <FormField label="End Session Method">
                <select id="end_session_method" name="end_session_method"
                        value={this.state.end_session_method}
                        onChange={(x) => this.setState({ end_session_method: x.target.value })}>
                  <option value="wait_and_cleanup">wait_and_cleanup</option>
                  <option value="skip_wait">skip_wait</option>
                  <option value="skip_cleanup">skip_cleanup</option>
                  <option value="skip_wait_skip_cleanup">skip_wait_skip_cleanup</option>
              </select>
            </FormField>
            {!activeSession &&
            <ColFlexDiv style={{'width': '80%', 'alignItems': 'flex-start'}}>                  
              <FormField label="Session Spec">
                <select id="session_spec_name" name="session_spec_name"
                        value={this.state.session_spec_name}
                        onChange={(x) => this.setState({ session_spec_name: x.target.value })}>
                  {sessionSpecs}
                </select>
              </FormField>
                <SessionClickableContainer onClick={() => window.location.href='/actor/start_session/actor/'+this.state.session_spec_name}
                                            style={{'marginTop': '5px', 'width': '100%'}} >
                  <RowFlexDiv><MixerLogo /></RowFlexDiv>
                  Kickoff Actor Session
                </SessionClickableContainer>
            </ColFlexDiv>

            }
            {!!activeSession &&
              <SessionClickableContainer onClick={() => window.location.href='/actor/end_session/actor/'+this.state.end_session_method}>
                <RowFlexDiv><MixerLogo /></RowFlexDiv>
                End Actor Session
              </SessionClickableContainer>
            }
            <FormField label="TempKey for Bot Session (if not main mixer account)" error={this.state.error}>
              <SessionTextArea
                style={{'height': '50px'}}
                name="tempkey"
                placeholder=""
                onChange={(x) => this.setState({ tempkey: x.target.value })}
                value={this.state.tempkey}
                ref={this.textInput}
              />
            </FormField>
            {!botSession &&
              <SessionClickableContainer 
                onClick={async () => {
                  const tempKey = this.state.tempkey; // Retrieve this dynamically if needed

                  try {
                    const response = await fetch('/actor/start_session/bot', {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json'
                      },
                      body: JSON.stringify({ tempkey: tempKey })
                    });

                    const data = await response.json();

                    if (response.ok) {
                      window.location.href = `/actor`; // Redirect after successful request
                    } else {
                      console.error("Error:", data.error);
                    }
                  } catch (error) {
                    console.error("Request failed", error);
                  }
                }}
              >
                <RowFlexDiv><MixerLogo /></RowFlexDiv>
                Kickoff a Bot Session
              </SessionClickableContainer>
            }
            {!!botSession &&
              <SessionClickableContainer onClick={() => window.location.href='/actor/end_session/bot/'+this.state.end_session_method}>
                <RowFlexDiv><MixerLogo /></RowFlexDiv>
                End Bot Session
              </SessionClickableContainer>
            }
            {!botTrainingSession &&
              <SessionClickableContainer onClick={() => window.location.href='/actor/start_session/bot_training'}>
                <RowFlexDiv><MixerLogo /></RowFlexDiv>
                Kickoff a Bot Training Session
              </SessionClickableContainer>
            }
            {!!botTrainingSession &&
              <SessionClickableContainer onClick={() => window.location.href='/actor/end_session/bot_training/'+this.state.end_session_method}>
                <RowFlexDiv><MixerLogo /></RowFlexDiv>
                End Bot Training Session
              </SessionClickableContainer>
            }
            <SessionClickableContainer onClick={() => window.location.href='/actor/new_session_spec'}>
              <RowFlexDiv><MixerLogo /></RowFlexDiv>
              Write an Actor Session Spec
            </SessionClickableContainer>
          </ColFlexDiv>
        }
      </PageWrapper>
    );
  }
}

export default ActorAdmin;